//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const UserMigration: FeatureFlag = {"Id":"UserMigration","Label":"[10.18]User migration","Impact":"Enable the user migration SSO flow including migrate, confirm, and federate endpoints.","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
